import { render, staticRenderFns } from "./AddBrandDataButton.vue?vue&type=template&id=11ffc9bc&scoped=true"
import script from "./AddBrandDataButton.vue?vue&type=script&lang=js"
export * from "./AddBrandDataButton.vue?vue&type=script&lang=js"
import style0 from "./AddBrandDataButton.vue?vue&type=style&index=0&id=11ffc9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffc9bc",
  null
  
)

export default component.exports